module.exports = __webpack_public_path__ + "img/c03_unitvillager_Normal_ua.0a489ad8.webp";